import { render, staticRenderFns } from "./SaleDetailQuery.vue?vue&type=template&id=f215ecb2&scoped=true"
import script from "./SaleDetailQuery.vue?vue&type=script&lang=js"
export * from "./SaleDetailQuery.vue?vue&type=script&lang=js"
import style0 from "./SaleDetailQuery.vue?vue&type=style&index=0&id=f215ecb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f215ecb2",
  null
  
)

export default component.exports